import store from "@/store";
import axios from "axios";
import {toast} from "../class/Notification";
import router from "@/router";
import {findObjectIndex} from "../class/Converter";
import {formatNumber} from "../class/Converter";
import {queryBuilder, filters} from '../class/QueryFilter'
import {generateHash} from "./ShoppingCart";
import {unFilteredFeatureTypes} from "./Feature";

let filtersCopy = JSON.parse(JSON.stringify(filters))

const setValueEmpty = (value) => {
    if (value == null) {
        return ''
    }
    return value
}

export const checkValueIsNumber = (value) => {
    return !isNaN(parseFloat(value)) && isFinite(value)
}

/* resolveFeatureObject method inspire from https://github.com/deki23/postman-json-to-form-data/blob/main/index.html */
export const validFeatureShapeKeyNames = [
    'child',
    'feature_id',
    'variation',
    'feature_value',
    'extra',
    'item_order',
    'category',
    'category_order',
    'group',
]

function resolveFeatureObject(name, object, formData) {
    let unValidItem = ['feature_attribute_id', 'featureImage', 'quantity', 'price', 'offer', 'id', 'image'];
    for (const [key, value] of Object.entries(object)) {

        if (!(value instanceof File)) {
            if (value instanceof Object) {
                resolveFeatureObject(`${name}[${key}]`, value, formData);
                continue;
            }
            if (value instanceof Array) {

                resolveFeatureArray(`${name}[${key}]`, value, formData);
                continue;
            }
        }


        if (key == 'featureImage' && value != null) {

            formData.append(`${name}[image]`, value);
        }

        if (['quantity', 'price', 'offer'].indexOf(key) > -1) {
            formData.append(`${name}[${key}]`, setValueEmpty(value))
        }

        if (key == 'id' && value != null && checkValueIsNumber(value)) {
            formData.append(`${name}[${key}]`, value);
        }

        if (key == 'feature_attribute_id' && value != undefined) {
            formData.append(`${name}[${key}]`, value);
        }


        if (validFeatureShapeKeyNames.indexOf(key) > -1) {
            formData.append(`${name}[${key}]`, value);
        }


    }
}

function resolveFeatureArray(name, array, formData) {

    array.forEach((value, index) => {
        if (value instanceof Object) {
            resolveFeatureObject(`${name}[${index}]`, value, formData);
            return;
        }

        if (value instanceof Array) {
            resolveFeatureArray(`${name}[${index}]`, value, formData);
            return;
        }
        formData.append(`${name}[${index}]`, value)
    })
}

export const removeChildFeature = (features) => {
    return features.filter(item => {
        if (item.variation == 0 || (item.variation == 1 && item.sub_product == 1)) {
            return item
        }
    })
}


const setProductFeatureShapeToFormData = (formData, features) => {
    const jsonObject = features;
    for (const [key, value] of Object.entries(jsonObject)) {

        if (value instanceof Object) {
            resolveFeatureObject(key, value, formData);
            continue;
        }

        if (value instanceof Array) {
            resolveFeatureArray(key, value, formData);
        }

    }
}

export const findLinkFeatureId = (id, data) => {
    // Loop through the array and look for an item with id equal to the input id
    for (let item of data) {
        if (item.id == id) {
            return item.link_feature_id;
        }
    }
    // Return null if no item is found
    return null;
}


export const findFeatureChild = (featureItemId, originalFeatures) => { // power by Bing

    // Initialize an empty array to store the parents
    let parents = [];
    // Loop through the array and look for an item with id equal to link_feature_id of the input id
    for (let item of originalFeatures) {
        if (item.id === findLinkFeatureId(featureItemId, originalFeatures)) {
            // Add the item to the parents array
            parents.push(item);
            // Recursively find the parents of the item and add them to the array
            parents = parents.concat(findFeatureChild(item.id, originalFeatures));
        }
    }
    // Return the parents array
    return parents;

}

const setChildOfVariationProductFeature = (rootFeatures, originalFeatures) => {
    rootFeatures.forEach(item => {

        if (item.variation == 1 && item.sub_product == 1) {
            let childs = findFeatureChild(item.id, originalFeatures)
            item['child'] = childs
        }

    })
    return rootFeatures
}

const productDataShape = (form) => {
    let formData = new FormData();

    for (let i in form.selectedCategory) {
        formData.append(`category_id[${i}]`, form.selectedCategory[i].id);
    }
    for (let i in form.keyWords) {
        formData.append(`keywords[${i}]`, form.keyWords[i]);
    }


    for (let [index, value] of Object.entries(form.images)) {
        formData.append(`images[${index}]`, value);
    }

    formData.append("thumbnail", form.mainImage);
    formData.append("name", form.name);
    const brand = (form.selectedBrand == undefined || form.selectedBrand == '' || form.selectedBrand == null) ? '' : form.selectedBrand.id;
    formData.append("brand_id", brand);
    formData.append("link", form.link);
    formData.append("bonus", form.bonus);
    formData.append("order", form.order);
    formData.append("barcode", form.barcode);

    formData.append("description", form.description);
    formData.append("is_digital", form.is_digital ? 1 : 0);
    formData.append("variation", form.variation);
    formData.append("language_id", form.language_id);

    if (form.variation == false) {
        formData.append("price", form.price != null ? form.price : "");
        formData.append("offer", form.discount != null ? form.discount : "");
        formData.append("quantity", form.quantity != null ? form.quantity : "");
        formData.append("delivery_amount", form.shippingCost != null ? form.shippingCost : "");
    }

    formData.append("status", form.published ? 1 : 0);


    let rootFeature = removeChildFeature(form.features);
    let originalFeatures = Object.assign([], form.features)
    let features = setChildOfVariationProductFeature(rootFeature, originalFeatures)
    features = {features: features}
    setProductFeatureShapeToFormData(formData, features)

    return formData;
};

export const productFeatureSubProduct = (product) => {
    return product.feature_product.filter(item => {
        if (item.sub_product == 1) {
            return item
        }
    })
}

export const getProductPriceRange = (product, format = 'string') => {

    if (product.variation == 0) {
        if (format = 'string') {
            return formatNumber(product.price)
        } else {
            return {min: product.price, max: product.price}
        }
    } else {
        let result = [];
        let subProduct = productFeatureSubProduct(product)
        subProduct.forEach(feature => {

            let price = feature.price
            let offer = feature.offer

            result.push(price - offer)


        })

        // sort numbers
        result = result.sort((a, b) => a - b);
        // get the lowest number
        let min = result[0];
        // get the highest number
        let max = result[result.length - 1];

        result = {min: min, max: max};

        if (format == 'string') {
            return `${formatNumber(result.min)} - ${formatNumber(result.max)}`
        } else {
            return result
        }

    }
}

export const getProductOfferRange = (product, format = 'string') => {

    if (product.variation == 0) {
        if (format == 'string') {
            return formatNumber(product.offer)
        } else {
            return {min: product.offer, max: product.offer}
        }
    } else {
        let result = [];
        let subProduct = productFeatureSubProduct(product)
        subProduct.forEach(feature => {
            let offer = feature.offer
            result.push(offer)
        })

        // sort numbers
        result = result.sort((a, b) => a - b);
        // get the lowest number
        let min = result[0];
        // get the highest number
        let max = result[result.length - 1];

        result = {min: min, max: max};

        if (format == 'string') {
            return `${formatNumber(result.min)} - ${formatNumber(result.max)}`
        } else {
            return result
        }

    }
}


/* return boolean and tell us product has offer or not */
export const productOfferChecker = (product) => {
    let offerObject = getProductOfferRange(product, 'object')
    let unValidData = [null, 0, undefined, '0']
    if (unValidData.indexOf(offerObject['min']) > -1 || unValidData.indexOf(offerObject['max']) > -1) {
        return false
    }

    return true
}

/* depricated method */
export const productPrice_depricate = (product) => {
    const item = product;
    const sub_product = item.sub_product
    product = product.product
    let price = {offer: 0, price: 0}
    if (product.variation == 0) {
        price.price = product.price
        price.offer = product.offer
    }
    if (product.variation == 1) {

        const product_features = product.features;

        for (let feature in product_features) {
            feature = product_features[feature]
            if (feature.feature_values.link_feature_value != null && feature.feature_values.link_feature_value.id == sub_product) {
                const base = feature.feature_values.link_feature_value;
                price.price = base.price
                price.offer = base.offer
            }
            if (feature.feature_values.link_feature_value == null && feature.feature_values.id == sub_product) {
                const base = feature.feature_values;
                price.price = base.price
                price.offer = base.offer
            }
        }

    }
    return price
}

export const productPriceOnUnAuthShoppingCard = (sub_product, product) => {
    let price = {offer: 0, price: 0}
    if (product.variation == 0) {
        price.price = product.price
        price.offer = product.offer
    }
    if (product.variation == 1) {

        price.price = sub_product.price
        price.offer = sub_product.offer

    }
    return price
}

/*
* return product name and his selected variable in variarion product
* */
export const productName = (product, subProductId = null) => {

    if (product.variation == 1) {
        let featureName = productFeatureName(product, subProductId)
        return `${product.name} ${featureName}`
    }

    return product.name

}
/*
* find subProduct of each product.
* for get full name of each item use `productName` method
* */
export const subProducts = (product) => {
    if (product.variation == 0) {
        return [product]
    }

    let product_features = product.feature_product


    let subProducts = product_features.filter(item => {
        if (item.variation == 1 && item.sub_product == 1) {
            return item
        }
    })

    return subProducts


}

export const defaultProductImage = 'data:image/svg+xml;base64,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';

export const productThumbnail = (product) => {
    if (product.thumbnail == null) {
        return defaultProductImage
    }
    return product.thumbnail
}

export const productFeatureName = (product, featureId) => {
    // use `features` because we save product features as `features` variable only in dashboard.
    let originalFeatures = Object.keys(product).includes('features') ? product.features : product.feature_product
    originalFeatures = JSON.parse(JSON.stringify(originalFeatures))


    // support grouped feature like checkbox to show feature name.
    if (Array.isArray(featureId)) {
        return featureId[0].feature.name
    }

    let featureProduct = originalFeatures.find(item => item.id == featureId)

    if (featureProduct.variation == 0) {
        return featureProduct.feature.name
    }

    if (featureProduct.variation == 1) {
        let featureProductChild = findFeatureChild(featureProduct.id, originalFeatures)
        let name = '';
        name += featureProduct.feature_attribute.value
        featureProductChild.forEach(item => {
            name += ' - ' + item.feature_attribute.value
        })
        return name
    }

    return false
}

export const productFeatureValue = (product, featureId) => {
    let originalFeatures = Object.keys(product).includes('features') ? product.features : product.feature_product
    originalFeatures = JSON.parse(JSON.stringify(originalFeatures))

    let featureProduct = originalFeatures.find(item => item.id == featureId)

    if (['checkbox', 'link'].indexOf(featureProduct.feature.type) > -1) {

        let foundedItem = originalFeatures.filter(item => {
            if (item.feature.public_name == featureProduct.feature.public_name) return item
        })

        return foundedItem
    }


    if (unFilteredFeatureTypes.indexOf(featureProduct.feature.type) > -1 && featureProduct.feature.type != 'formula') {
        return featureProduct.feature_value
    }
    /* find value of listWithValue feature type */
    let featureListValue = ''
    let featureAttributeValue = ''
    if (['list-with-number-value', 'list-with-text-value'].indexOf(featureProduct.feature.type) > -1) {
        featureListValue = featureProduct.feature.type == 'list-with-number-value' ? formatNumber(featureProduct.feature_value) : featureProduct.feature_value
    }


    if (featureProduct.feature_attribute != null) {
        featureAttributeValue = featureProduct.feature_attribute.value
    }

    return `${featureAttributeValue} ${featureListValue}`
}

export const productTableFeature = (product) => {
    let features = []
    let productFeatures = product.feature_product
    if (productFeatures != undefined) {
        features = productFeatures.filter(item => {
            if (item.sub_product == 0 && item.variation == 0) {
                return item
            }
        })
    }
    return features
}


export const baseFeature = {
    "id": 'generate-random-string', // use on delete section for unsaved data in database
    "product_id": null,
    "feature_id": null,
    "feature_value": null,
    "feature_attribute_id": null,
    "variation": 0,
    "extra": {
        "item_order": "1", "category": "بدون دسته بندی", "category_order": "1", "group": 'generate-random-string'
    },
    "link_feature_id": null,
    "price": null,
    "offer": 0,
    "quantity": null,
    "sub_product": 0,
    "image": null,
    "deleted_at": null,
    "feature": {
        "id": 3,
        "name": "جنسیت",
        "public_name": "جنسیت",
        "type": "list",
        "language_id": null,
        "image": null,
        "feature_attributes": [{
            "id": 8,
            "feature_id": 3,
            "value": "خانم",
            "filterable": 0,
            "image": null,
            "deleted_at": null,
            "created_at": "2022-10-30T01:10:20.000000Z",
            "updated_at": "2022-10-30T01:10:20.000000Z"
        }, {
            "id": 9,
            "feature_id": 3,
            "value": "آقا",
            "filterable": 0,
            "image": null,
            "deleted_at": null,
            "created_at": "2022-10-30T01:12:36.000000Z",
            "updated_at": "2022-10-30T01:12:36.000000Z"
        }, {
            "id": 46,
            "feature_id": 3,
            "value": "پسر",
            "filterable": 0,
            "image": null,
            "deleted_at": null,
            "created_at": "2022-11-02T12:38:54.000000Z",
            "updated_at": "2022-11-02T12:38:54.000000Z"
        }, {
            "id": 47,
            "feature_id": 3,
            "value": "دختر",
            "filterable": 0,
            "image": null,
            "deleted_at": null,
            "created_at": "2022-11-02T12:38:59.000000Z",
            "updated_at": "2022-11-02T12:38:59.000000Z"
        }],
    },
    "feature_attribute": {
        "id": 9,
        "feature_id": 3,
        "value": "آقا",
        "filterable": 0,
        "image": null,
        "deleted_at": null,
        "created_at": "2022-10-30T01:12:36.000000Z",
        "updated_at": "2022-10-30T01:12:36.000000Z"
    }
}

/*
* used on addFeatureToProduct and it's kind of helper
* */
const findFeatureWithAttribute = (features, attribute) => {
    let result = null
    features.forEach(feature => {
        let featureAttributes = feature.feature_attributes
        featureAttributes.forEach(featureAttribute => {
            if (featureAttribute.id == attribute.id) {
                result = feature
            }
        })
    })

    return result

}

export const addFeatureToProduct = (feature, product) => {
    let baseFeatureClone = JSON.parse(JSON.stringify(baseFeature))
    baseFeatureClone['id'] = generateHash().slice(0, 16)
    baseFeatureClone['extra']['group'] = generateHash().slice(0, 16)
    if (product.variation == 1 && Object.keys(feature).indexOf('selectedFeature') > -1) {

        let attributes = feature['attributes']
        let selectedFeature = feature['selectedFeature']
        attributes = attributes.reverse()
        let lastFeatureLink = null
        let feature_depth = attributes.length
        product.feature_depth = feature_depth

        attributes.forEach((attribute, index) => {

            baseFeatureClone['feature_attribute'] = attribute
            baseFeatureClone['variation'] = 1
            baseFeatureClone['feature_attribute_id'] = attribute.id

            let findAttributeOnSelectedFeature = findFeatureWithAttribute(selectedFeature, attribute)

            baseFeatureClone['feature_id'] = findAttributeOnSelectedFeature.id
            baseFeatureClone['feature'] = findAttributeOnSelectedFeature

            baseFeatureClone['link_feature_id'] = lastFeatureLink
            baseFeatureClone['sub_product'] = (index == (feature_depth - 1) ? 1 : 0)

            product.features.push(Object.assign({}, baseFeatureClone))
            lastFeatureLink = baseFeatureClone['id']
            // generate new id for next item
            baseFeatureClone['id'] = generateHash().slice(0, 16)

        })


    } else {
        baseFeatureClone['feature_id'] = feature.id
        baseFeatureClone['feature'] = feature

        const firstFeatureAttribute = feature.feature_attributes.slice(0, 1)[0];

        if (unFilteredFeatureTypes.indexOf(feature.type) > -1) {
            baseFeatureClone['feature_value'] = firstFeatureAttribute.value
        } else {
            baseFeatureClone['feature_attribute_id'] = firstFeatureAttribute.id
        }

        baseFeatureClone['feature_attribute'] = firstFeatureAttribute

        baseFeatureClone['variation'] = 0

        product.features.push(Object.assign({}, baseFeatureClone))
    }


}


export const featureCategories = (features) => {
    let categories = []

    features.forEach((item) => {

        categories.push(item.extra)

    })

    return categories

}

export const groupByType = (features) => {
    Object.entries(features).forEach(item => {
        let group = item[0]
        let items = item[1]
        let checkboxGroup = features[group].reduce((acc, item) => {
            if (["checkbox", 'checkbox-step'].indexOf(item.feature.type) > -1) {
                let checkboxGroupName = item.extra.group
                if (!acc[checkboxGroupName]) {
                    acc[checkboxGroupName] = [];
                }
                acc[checkboxGroupName].push(item);
            }
            return acc;
        }, {})
        let unCheckboxGroup = features[group].filter(item => ["checkbox", 'checkbox-step'].indexOf(item.feature.type) === -1)
        features[group] = []
        Object.entries({...checkboxGroup, ...unCheckboxGroup}).forEach(newGenFeature => {
            let item = newGenFeature[1];
            if (Array.isArray(item)) {
                features[group].push({
                    items: item,
                    extra: item[0].extra
                })
            } else {
                features[group].push(item)
            }
        })
        features[group].sort((a, b) => b.extra.item_order - a.extra.item_order)

    })


    let result = {}
    // set order of checkbox group to correct order
    Object.entries(features).forEach(reshapeFeature => {
        let group = reshapeFeature[0]
        let items = reshapeFeature[1]
        result[group] = []
        items.forEach(item => {
            if (item.items != undefined) {
                result[group].push(item.items)
            } else {
                result[group].push(item)
            }
        })
    })
    return result
}

export const removeEmptyGroups = (features) => {
    let result = {}

    Object.entries(features).forEach(item => {
        let group = item[0]
        let items = item[1]
        if (items != undefined && items.length > 0) {
            result[group] = items
        }
    })

    return result

}

export const sortedFeaturesMethod = (features) => {
    let originalFeatures = Object.assign([], features)
    features = removeChildFeature(features)

    // sort features base on item_order
    features = features.sort((a, b) => b.extra.item_order - a.extra.item_order);

    // group features base on category
    let featureGroup = features.reduce((acc, item) => {
        const category = item.extra.category;

        if (!acc[category]) {
            acc[category] = [];
        }

        acc[category].push(item);

        return acc;
    }, {});


    // add category info to each group
    let allFeatureCategories = featureCategories(originalFeatures)

    allFeatureCategories.sort((a, b) => b.category_order - a.category_order);
    let sortedFeatureGroup = {};
    for (let i = 0; i < allFeatureCategories.length; i++) {
        let category = allFeatureCategories[i].category;
        sortedFeatureGroup[category] = featureGroup[category];
    }

    // remove empty groups
    sortedFeatureGroup = removeEmptyGroups(sortedFeatureGroup)

    return groupByType(sortedFeatureGroup)
}

export const findFeatureWithSelectedName = (product, featureName) => {

    let featureProduct = product.feature_product

    if (featureProduct == null || featureProduct.length == 0) {
        return ''
    }

    let foundedItem = featureProduct.find(item => {
        if (item.feature.public_name == featureName) {
            return item
        }
    })
    return foundedItem == undefined ? '' : productFeatureValue(product, foundedItem.id)
}

export default {
    namespaced: true,
    state: {
        products: [],
        product: {},
        productBrand: {}, ...filtersCopy,
        trash: [],
        meta: {},
        latestProducts: [],
        favoriteProducts: [],
        productComments: [],
        productUsers: [],
        offerProducts: [],
    },
    mutations: {
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
        setProducts(state, products) {
            state.products = products;
        },
        setProduct(state, product) {
            state.product = product;
        },
        setProductBrand(state, brand) {
            state.productBrand = brand;
        },
        deleteProduct: (state, product) => {
            state.products.splice(findObjectIndex(store.getters["Product/getProducts"], product), 1);
            state.trash.splice(findObjectIndex(store.getters["Product/getTrash"], product), 1);
        },
        setTrash(state, products) {
            state.trash = products;
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        setLatestProducts(state, latestProducts) {
            state.latestProducts = latestProducts;
        },
        setFavoriteProduct(state, favoriteProducts) {
            state.favoriteProducts = favoriteProducts
        },
        setProductComments(state, comments) {
            state.productComments = comments
        },
        setProductUsers(state, users) {
            state.productUsers = users
        },
        setOfferProducts(state, products) {
            state.offerProducts = products
        }
    },
    actions: {
        setProducts({commit, state}, page = 1) {
            // convert filter items to query string
            const query = queryBuilder(state.filters)
            axios.get(`product?page=${page}&${query}`)
                .then((res) => {
                    let products = res.data.data;
                    commit("setProducts", products.data);
                    commit("setMeta", products.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setDashboardProducts({commit, state}, page = 1) {
            // convert filter items to query string
            const query = queryBuilder(state.filters)

            let req = axios.get(`dashboard/product?page=${page}&${query}`)

            req.then((res) => {
                let products = res.data.data;
                commit("setProducts", products.data);
                commit("setMeta", products.meta);
            })
                .catch((error) => {
                    console.log(error);
                });
            return req
        },
        filteredProducts({commit, state}, filters) {
            const query = queryBuilder(state.filters)
            axios
                .get(`/general-search?${query}`)
                .then((res) => {
                    const products = res.data.data;
                    commit("setProducts", products.data);
                    commit("setMeta", []);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getProduct({commit}, link) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`product/${link}`)
                    .then((response) => {
                        response = response.data.data;
                        commit("setProduct", response);
                        commit("setProductBrand", response.brand);
                        resolve(response);
                    })
                    .catch((error) => {
                        router.push({name: "NotFound"});
                        reject(error);
                    });
            });
        },
        getDashboardProduct({commit}, link) {
            let request = axios.get(`dashboard/single/product/${link}`);

            request.then((response) => {
                response = response.data.data;
                commit("setProduct", response);
                commit("setProductBrand", response.brand);

            })
                .catch((error) => {
                    router.push({name: "NotFound"});

                });

            return request
        },
        createProduct({commit}, form) {
            let formData = productDataShape(form);
            if (form.mainImage === undefined || form.mainImage.length === 0) {
                formData.delete("thumbnail");
            }
            return axios.post("/product", formData)

        },
        async showProduct({commit}, form) {
            return await axios.get(`/product/${form.link}`);
        },
        updateProduct({commit}, form) {
            let formData = productDataShape(form);


            if (form.mainImage === undefined || form.mainImage.length === 0) {
                formData.delete("thumbnail");
            }


            formData.append("_method", "PUT");
            /*for (var pair of formData.entries()) {
                console.log(pair[0] + ', ' + pair[1]);
            }*/
            return axios.post(`/product/${form.id}`, formData)
        },
        deleteImage({commit}, index) {
            const product = store.getters["Product/getProduct"];
            const image = product.images[index];
            const form = {
                _method: "DELETE", images: [image.id],
            };

            return axios.post(`product/${product.id}/delete-image`, form)
        },
        deleteImageProductGalleryInStepManager({commit}, form) {
            return axios.post(`product/${form.id}/delete-image`, form)
        },
        deleteProduct({commit}, product) {
            axios
                .delete(`/product/${product.id}`)
                .then((res) => {
                    const deletedProduct = res.data.data;
                    commit("deleteProduct", deletedProduct);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getTrash({commit}, page = 1) {
            axios
                .post(`/product/trash?page=${page}`)
                .then((res) => {
                    let products = res.data.data;
                    commit("setTrash", products.data);
                    commit("setMeta", products.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        restoreProduct({commit}, product) {
            axios
                .put(`/product/${product.id}/restore`)
                .then((res) => {
                    const restoredProduct = res.data.data;
                    commit("deleteProduct", restoredProduct);
                    const products = {
                        ...store.getters["Product/getProducts"], restoredProduct,
                    }; // todo : fix issue of send array instead of object
                    commit("setProducts", products);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        forceDeleteProduct({commit}, product) {
            axios
                .delete(`/product/${product.id}/force-delete`)
                .then((res) => {
                    const deletedProduct = res.data.data;
                    store.dispatch('Product/getTrash')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getLatestProducts({commit}) {

            axios.get(`product?page=1&is_digital=0`)
                .then((res) => {
                    let products = res.data.data;
                    commit("setLatestProducts", products.data);
                    commit("setMeta", products.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getFavoriteProducts({commit}) {
            axios.get(`favorite/products`)
                .then((res) => {
                    let products = res.data.data;
                    commit("setFavoriteProduct", products);
                    commit("setMeta", products.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getProductComments({commit}, productId) {
            // todo تابع پاک شود و از نسخه موجود در ماژول کامنت در صفحه محصول استفاده شود.
            axios.get(`product/${productId}/comments`)
                .then((res) => {
                    let comments = res.data.data;
                    commit("setProductComments", comments.data);
                    commit("setMeta", comments);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getProductUsers({commit}, form) {

            let req = axios.post(`product/products-user/${form.product_id}`, form)

            req.then((res) => {
                let users = res.data.data;
                commit("setProductUsers", users);
            })
                .catch((error) => {
                    console.log(error);
                });

            return req
        },
        addUserToProduct({commit}, form) {
            return axios.post(`product/add-user-to-product/${form.product_id}/user/${form.user_id}`, form);
        },
        removeUserProduct({commit}, form) {
            return axios.post(`product/remove-user-product/${form.product_id}/user/${form.user_id}/order/${form.order_id}`, form);
        },
        getOfferProducts({commit}, page) {
            axios.get(`/products/with-offer?page=${page}`)
                .then((res) => {
                    let products = res.data.data;
                    commit("setOfferProducts", products.data);
                    commit("setMeta", products.meta);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteProductFeature({commit}, form) {
            const res = axios.delete(`feature-product/remove-feature/${form.product_id}`, {data: form});

            res.then((res) => {
                toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
            })
                .catch((error) => {
                    console.log(error);
                });
            return res
        },
        updateFeatureOfTheProduct({commit}, form) {
            const formData = new FormData()
            formData.append(`_method`, 'put');
            if (form.type == 'list') {
                formData.append(`features[0][feature_id]`, form.update_info.feature_id);


                if (form.variation == 0 && form.type == 'list') {
                    formData.append(`features[0][feature_attribute_id]`, form.value);
                } else {
                    formData.append(`features[0][feature_attribute_id]`, form.update_info.feature_attribute_id);
                }

                formData.append(`features[0][feature_value]`, form.update_info.feature_value);
                formData.append(`features[0][variation]`, form.update_info.variation);

                formData.append(`features[0][quantity]`, form.quantity);
                formData.append(`features[0][price]`, form.price);
                formData.append(`features[0][offer]`, form.offer);
                if (form.image !== undefined) {
                    formData.append(`features[0][image]`, form.image == null ? '' : form.image);
                }

                axios.post(`product/${form.update_info.product_id}/update-feature/feature-product/${form.update_info.id}`, formData)
                    .then((res) => {
                        toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
                    })
                    .catch((error) => {
                        console.log(error);
                    });


            } else {
                formData.append(`features[0][feature_id]`, form.feature_id);
                formData.append(`features[0][feature_attribute_id]`, form.feature_attributes);
                formData.append(`features[0][feature_value]`, form.value);
                formData.append(`features[0][variation]`, form.variation);
                formData.append(`features[0][quantity]`, form.quantity);
                formData.append(`features[0][price]`, form.price);
                formData.append(`features[0][offer]`, form.offer);


                axios.post(`product/${form.product_id}/update-feature/feature-product/${form.id}`, formData)
                    .then((res) => {
                        toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
                    })
                    .catch((error) => {
                        console.log(error);
                    });


            }


        },
        createFeatureProduct({commit}, form) {
            const formData = new FormData()

            if (form.feature_id != undefined && form.feature_id.length > 0) {

                formData.append(`features[0][feature_id]`, form.feature_id[0]);
                formData.append(`features[0][feature_attribute_id]`, form.feature_attributes[0]);
                formData.append(`features[0][variation]`, 1);

                formData.append(`features[0][quantity]`, form.quantity);
                formData.append(`features[0][price]`, form.price);
                formData.append(`features[0][offer]`, form.offer);
                formData.append(`features[0][image]`, form.image === undefined ? '' : form.image);
                if (form.feature_id.length > 1) {
                    formData.append(`features[0][link_feature_id][id]`, form.feature_id[1]);
                    formData.append(`features[0][link_feature_id][attribute_id]`, form.feature_attributes[1]);

                    formData.append(`features[0][link_feature_id][quantity]`, form.quantity);
                    formData.append(`features[0][link_feature_id][price]`, form.price);
                    formData.append(`features[0][link_feature_id][offer]`, form.offer);
                    formData.append(`features[0][link_feature_id][variation]`, 0);
                }


            } else {
                formData.append(`features[0][feature_id]`, form.id);
                if (form.type == 'list') {
                    formData.append(`features[0][feature_attribute_id]`, form.value);
                }
                formData.append(`features[0][feature_value]`, form.value);
                // linked_feature_id

                formData.append(`features[0][variation]`, form.variation == undefined ? 0 : form.variation);
                if (form.quantity != undefined) formData.append(`features[0][quantity]`, form.quantity);
                if (form.price != undefined) formData.append(`features[0][price]`, form.price);
                if (form.offer != undefined) formData.append(`features[0][offer]`, form.offer);
                formData.append(`features[0][image]`, form.image === undefined ? '' : form.image);
            }

            return axios.post(`product/${form.product_id}/add-feature`, formData);
        },
        updateQuantityPriceOffer({commit}, form) {
            axios
                .post(`/product/update/general-info`, form)
                .then((res) => {
                    toast("عملیات با موفقیت انجام شد", "محصول  با موفقیت ویرایش شد.");
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setProductsWithoutState({commit, state}, page = 1) {
            // convert filter items to query string
            const query = queryBuilder(state.filters)
            return axios.get(`product?page=${page}&${query}`)
        },
        getProductWithoutState({commit}, link) {
            return axios.get(`product/${link}`)
        },
        searchProduct({commit}, {form}) {
            axios
                .get(`/general-search?search=${form.words}`)
                .then((res) => {
                    const products = res.data.data;
                    commit("setProducts", products.data);
                    commit("setMeta", []);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteProductFeatureImage({commit}, form) {
            const res = axios.delete(`feature-product/remove-image/${form.feature_product_id}`);

            res.then((res) => {
                toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
            })
                .catch((error) => {
                    console.log(error);
                });
            return res
        },
        async getArchiveFilters({commit, state}) {
            const query = queryBuilder(state.filters)
            let req = await axios.post(`dynamic/filter?${query}`)
            return req
        },
        async findNearestProduct({commit, state}, form) {
            const query = queryBuilder(state.filters)
            let req = await axios.post(`find-nearest-product?page=${form.page}&${query}`,form)
            return req
        },
        async decreaseValueForShowUserCellphone({commit, state},form) {
            let req = await axios.post(`wallet/decrease-value-form-show-cellphone-of-user/${form.product_id}`)
            return req
        },
        async getArchiveFiltersRangePrice({commit, state}) {
            let req = await axios.get(`dynamic-filter/price-range`)
            return req
        },
    },
    getters: {
        getProducts: (state) => state.products,
        getProduct: (state) => state.product,
        getFilter: (state) => (key) => {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                return state.filters[key];
            }
        },
        getProductBrand: (state) => state.productBrand,
        getTrash: (state) => state.trash,
        getPaginationMeta: (state) => state.meta,
        getLatestProduct: (state) => state.latestProducts,
        getFavoriteProducts: (state) => state.favoriteProducts,
        getProductComments: (state) => state.productComments,
        getProductUsers: (state) => state.productUsers,
        getOfferProducts: (state) => state.offerProducts,
        getFilters: (state) => state.filters
    },
};
